import React from "react";

import Heading from "../home/components/Heading";
import Footer from "../home/components/Footer";
import ContentSection from "../home/components/ContentSection";

import { hashHistory } from "browserHistory";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";

import styled from "styled-components";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

const BlogPost = styled.div`
  margin: 10px 0 10px 0;
  border-top: 1px solid #aaa;
  padding: 10px 0 10px 0;
  cursor: pointer;
  max-width: 700px;
`;

const BlogTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
`;

const BlogText = styled.div`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const BlogBy = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #6e80fd;
`;

const BlogDate = styled.div`
  font-size: 14px;
`;

export default () => {
  return (
    <div>
      <style>
        {`h1 {

        }
        h2 {
          color: #868686;
          margin-bottom: 40px;
        }`}
      </style>
      <Heading maxWidth={1000} showButtons={true} />
      <Page>
        <ContentSection maxWidth={1000}>
          <div>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/">
                RoboPPA Home
              </Link>
              <Typography color="textPrimary">Blog Posts</Typography>
            </Breadcrumbs>
          </div>
          <h1>RoboPPA Blog</h1>
          <h2>Announcements, guides, and articles about RoboPPA.</h2>
          <div>
            <BlogPost
              onClick={() => {
                hashHistory.push("/Blog/2");
              }}
            >
              <div>
                <BlogTitle>
                  Performance Analysis of Managed Portfolios with Transfers and
                  Proper Benchmarks
                </BlogTitle>
                <BlogText>
                  Benchmark portfolios are market alternatives to managed
                  portfolios and typically have lower expenses. They may also
                  have preferred Risk and Return properties. The preferred
                  portfolio depends on the proper analysis of their comparative
                  performance.
                </BlogText>
                <div>
                  <BlogBy>Bob Korkie</BlogBy>
                  <BlogDate>March 7, 2021</BlogDate>
                </div>
              </div>
            </BlogPost>
            <BlogPost
              onClick={() => {
                hashHistory.push("/Blog/1");
              }}
            >
              <div>
                <BlogTitle>
                  The Effect of Contributions and Withdrawals on the Reporting
                  of Portfolio Performance
                </BlogTitle>
                <BlogText>
                  If there is a single measure of a portfolio’s performance over
                  an analysis period, the annualized return is likely the most
                  preferred.
                </BlogText>
                <div>
                  <BlogBy>Bob Korkie</BlogBy>
                  <BlogDate>March 6, 2021</BlogDate>
                </div>
              </div>
            </BlogPost>
          </div>
        </ContentSection>
        <Footer />
      </Page>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/blog/BlogListing.js